<template>
    <div>
        <div class="bg-blue-dark text-white">
            <div class="container mx-auto px-3 py-6 sm:p-6">
                
                <div class="md:flex md:-mx-3 md:items-center">
                    <div class="text-center md:text-left md:flex-1 md:px-3">
                        {{heading}}
                    </div>
                    <div class="pt-6 md:pt-0 md:flex-0 md:px-3 lg:min-w-300" v-for="(filter, index) in filters" :key="filter.alias">
                        <dropdown-input :alias="filter.alias"
                            :placeholder="filter.label"
                            :options="filter.options"
                            :class="'z-' + ((4 - index) * 10)"
                            :all-label="filter.allLabel"
                            v-model="selectedFilter" />
                    </div>
                </div>

            </div>
        </div>
        <slot v-bind:selected-filter="selectedFilter" />
    </div>
</template>

<script>
import DropdownInput from './_DropdownInput.vue';

export default {
    name: 'FilteredList',
    props: ['heading', 'filters'],
    components: { DropdownInput },
    data () {
        return {
            selectedFilter: false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/js/components/FilteredList.vue